<div class="access-denied-modal">
	<div class="icon-container">
		<i class="fa-solid fa-ban access-denied-icon"></i>
	</div>
	<div class="access-denied-content">
		<h2>{{ accessData?.title }}</h2>
		<p>{{ accessData?.message }}</p>
	</div>
	<div>
		<button mat-raised-button color="primary" (click)="onOkClick()">OK</button>
	</div>
</div>